import React from 'react';


class QuestionHeader extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            qTime:0,
            play:false,
            status:false,
        };
    }



    render(){
        let questionH = this.props.questionHeader;

        return(
            <div className="question-header">
            <div className="frage-header">
                <div className="questionId">
                    <span>
                        Frage {this.props.questionHeader.questionId}/{this.props.questionHeader.totalQuestion}
                    </span>
                </div>
                <div className="questionTimer">
                    <span className="time-label">
                        Zeit:
                    </span>
                    <span className="time-val">
                        {/*{this.props.questionHeader.timer}*/}
                        {/*{this.props.timer}*/}
                       {/* {this.props.questionHeader.timerUpdated}*/}
                        {this.props.timerUpdated}
                    </span>
                </div>
            </div>
              {/* <QuestionAudioPlayer questionAudio={this.props.questionHeader.audio}/>*/}
            </div>
        );
    }
}
export default QuestionHeader;
